import { useState, useEffect, useRef } from 'react';
import JqxTreeGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxtreegrid';
import { Flex, Heading, Button, FormControl, FormLabel, RadioGroup, Radio, Box, Spinner } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import CustomInput from '../../../../components/common/Input/input';
import * as api from '../../../../api/perfil-usuario';
import { listarMenus } from '../../../../api/menu';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb/SettingsBreadcrumb';
import './editar-perfil-usuario.scss';

interface MenuItem {
  codMenu: number;
  dscMenu: string;
  fkCodMenu: number;
  numRegistro: number;
  seqPerfilMenu: number | null;
}

function EditarPerfilUsuario() {
  const [listaMenus, setListaMenus] = useState<any[]>([]);
  const [selectedMenus, setSelectedMenus] = useState<any[]>([]);
  const [originalMenus, setOriginalMenus] = useState<any[]>([]);
  const [paiClicado, setPaiClicado] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();
  const treeGridRef = useRef<JqxTreeGrid>(null);

  const [formValues, setFormValues] = useState<any>({
    dscPerfilAcesso: { value: '', error: false },
    numRegistro: { value: 0, error: false },
    menus: { value: [], error: false }
  });

  const fetchNoticiaData = async () => {
    try {
      const userData = await api.obterPerfilUsuario(id);
      const { dscPerfilAcesso, numRegistro, menus } = userData;

      const originalMenus = menus.map((item: any) => ({
        codMenu: item.codMenu.toString(),
        seqPerfilMenu: item.seqPerfilMenu || null,
        numRegistro: item.numRegistro || 0
      }));

      setOriginalMenus(originalMenus);
      setSelectedMenus(menus.filter((item: any) => item.numRegistro === 1).map((item: any) => item.codMenu.toString()));
      setFormValues({
        dscPerfilAcesso: { value: dscPerfilAcesso, error: false },
        numRegistro: { value: numRegistro, error: false },
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Erro ao buscar dados do perfil:", error);
    }
  };

  const mergeMenuData = () => {
    return listaMenus.map(menu => {
      const originalMenu = originalMenus.find(
        (o: any) => o.codMenu === menu.codMenu.toString()
      );
      if (originalMenu) {
        return { ...menu, numRegistro: originalMenu.numRegistro };
      } else {
        return { ...menu, numRegistro: 0 };
      }
    });
  };

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const listaMenus = await listarMenus();
        setListaMenus(listaMenus);
      } catch (error) {
        console.error('Erro ao listar menus:', error);
      }
    };

    fetchMenus();
    fetchNoticiaData();
  }, []);


  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const listaMenus = await listarMenus();
        setListaMenus(listaMenus);
      } catch (error) {
        console.error('Erro ao listar menus:', error);
      }
    };

    fetchMenus();
    fetchNoticiaData();
  }, []);

  const handleCheckChange = (evento: any) => {
    const args = evento.args;
    const item: MenuItem = args.row;
    const marcado = args.checked;

    const pai = treeGridRef.current!.getRow(item.fkCodMenu) as MenuItem;

    const itemEstaMarcado = (item: MenuItem) => {
      return treeGridRef.current!.getCheckedRows().some((row: any) => row.codMenu === item.codMenu);
    };

    if (item && item.fkCodMenu != null) {
      if (marcado) {
        if (!paiClicado.includes(item.fkCodMenu)) {
          setPaiClicado(prevState => [...prevState, item.fkCodMenu]);
          pai.numRegistro = 1;
        }

        if (pai && !paiClicado.includes(pai.fkCodMenu)) {
          setPaiClicado(prevState => {
            const updatedPaiClicado = [...prevState];
            updatedPaiClicado.push(pai.fkCodMenu);
            return updatedPaiClicado;
          });
          pai.numRegistro = 1;
        }
      } else {
        if (paiClicado.includes(item.fkCodMenu)) {
          setPaiClicado(prevState => prevState.filter((id: number) => id !== item.fkCodMenu));

          const irmaos = treeGridRef.current!.getRows().filter((row: any) => (row as MenuItem).fkCodMenu === item.fkCodMenu);
          const todosIrmaosDesmarcados = irmaos.every((irmao: any) => {
            const menuItem = irmao as MenuItem;
            return !itemEstaMarcado(menuItem);
          });

          if (todosIrmaosDesmarcados) {
            pai.numRegistro = 0;
          }
        }

        if (pai && paiClicado.includes(pai.fkCodMenu)) {
          setPaiClicado(prevState => prevState.filter((id: number) => id !== pai.fkCodMenu));
          pai.numRegistro = 0;
        }
      }
    }
  };

  const handleSubmit = async () => {
    const { dscPerfilAcesso, numRegistro } = formValues;

    const selectedMenusIds = treeGridRef.current!.getCheckedRows().map((row: any) => row.codMenu.toString());

    const originalActiveMenusIds = originalMenus.filter(menu => menu.numRegistro === 1).map(menu => menu.codMenu.toString());

    const menusAlterados = !arraysIguais(selectedMenusIds, originalActiveMenusIds);

    const menus = menusAlterados ? listaMenus.map(menu => {
      const originalMenu = originalMenus.find(original => original.codMenu === menu.codMenu.toString());

      const isPaiMarcado = paiClicado.includes(menu.codMenu);

      return {
        codMenu: menu.codMenu,
        numRegistro: selectedMenusIds.includes(menu.codMenu.toString()) || isPaiMarcado ? 1 : 0,
        seqPerfilMenu: originalMenu ? originalMenu.seqPerfilMenu : null,
        codPerfilAcesso: Number(id),
        dataRegistro: new Date().toISOString().split('T')[0],
        menuDTO: {
          codMenu: menu.codMenu,
          dscMenu: menu.dscMenu,
          datRegistro: menu.datRegistro,
          numRegistro: 1,
          fkCodMenu: menu.fkCodMenu || null,
        },
      };
    }) : null;

    if (menus) {
      menus.forEach(menu => {
        if (menus && menu.menuDTO.fkCodMenu && menu.numRegistro === 1) {
          const paiMenu = menus.find(pai => pai.codMenu === menu.menuDTO.fkCodMenu);
          if (paiMenu) {
            paiMenu.numRegistro = 1;
          }
        }
      });
    }

    const params = {
      codPerfilAcesso: Number(id),
      dscPerfilAcesso: dscPerfilAcesso.value || '',
      numRegistro: numRegistro.value,
      menus: menus
    };

    try {
      await api.editarPerfilUsuario(Number(id), params);

      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Usuário editado com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        const obterAcessoMenu = () => {
          return menus?.filter(menu => menu.numRegistro === 1).map(menu => {
            return {
              seqPerfilMenu: menu.seqPerfilMenu,
              codPerfilAcesso: menu.codPerfilAcesso,
              codMenu: menu.codMenu,
              dataRegistro: menu.dataRegistro,
              numRegistro: menu.numRegistro,
              menuDTO: {
                codMenu: menu.menuDTO.codMenu,
                dscMenu: menu.menuDTO.dscMenu,
                datRegistro: menu.menuDTO.datRegistro,
                numRegistro: menu.menuDTO.numRegistro,
                fkCodMenu: menu.menuDTO.fkCodMenu || null,
              },
            };
          });
        };

        const data = obterAcessoMenu();
        if (data && data.length > 0) {

          let usuarioLogadoId: string | undefined = undefined;
          const usuarioDados = localStorage.getItem('dadosUsuario');

          if (usuarioDados) {
            const usuario = JSON.parse(usuarioDados);
            usuarioLogadoId = usuario.codPerfilAcesso;
          }

          if (usuarioLogadoId == id) {
            localStorage.setItem('permissaoAcesso', JSON.stringify(data));
            window.dispatchEvent(new Event('storage'));

            const codMenu2000Existe = selectedMenusIds.some(codMenu => {
              return codMenu >= '2000' && codMenu < '3000';
            });

            if (!codMenu2000Existe) {
              navigate('/cms/inicio');
              return;
            }
          }
        } else {
          let usuarioLogadoId: string | undefined = undefined;
          const usuarioDados = localStorage.getItem('dadosUsuario');

          if (usuarioDados) {
            const usuario = JSON.parse(usuarioDados);
            usuarioLogadoId = usuario.codPerfilAcesso;
          }

          if (usuarioLogadoId == id && data) {
            const isTodosDesativados = data.every((item) => {
              item.numRegistro == 0
            })
            
            if (isTodosDesativados) {
              Swal.fire({
                icon: 'warning',
                title: 'Alerta!',
                html: `Seu perfil de acesso não possui permissões associadas. <br/> Você não poderá utilizar a plataforma.`,
                confirmButtonColor: '#1789FC',
                confirmButtonText: 'OK',
              }).then(() => {
                localStorage.removeItem('permissaoAcesso');
                navigate('/login');
              });
            }
          }
        }
        navigate('/cms/configuracao/gerenciar-perfil-usuario');
      });
    } catch (error) {
      console.error('Erro ao editar usuário:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar usuário. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/configuracao/gerenciar-perfil-usuario');
      });
    }
  };

  const arraysIguais = (arr1: string[], arr2: string[]) => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  };

  const isFormValid = () => {
    const { dscPerfilAcesso } = formValues;
    return dscPerfilAcesso.value.length >= 3 && dscPerfilAcesso.value.trim();
  };

  const columns = [
    {
      text: 'Menus',
      dataField: 'dscMenu',
      align: 'left',
      width: '100%',
    },
  ];

  const getSource = () => ({
    datatype: 'json',
    localdata: mergeMenuData(),
    dataFields: [
      { name: 'codMenu', type: 'number' },
      { name: 'dscMenu', type: 'string' },
      { name: 'fkCodMenu', type: 'number' },
      { name: 'numRegistro', type: 'number' },
    ],
    id: 'codMenu',
    hierarchy: {
      keyDataField: { name: 'codMenu' },
      parentDataField: { name: 'fkCodMenu' },
    },
  });

  useEffect(() => {
    if (treeGridRef.current) {
      treeGridRef.current.expandAll();
    }
  }, [listaMenus]);

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading mt="30px" mb="20px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Perfil de Usuário
      </Heading>

      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <div className="row mb-3">
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Perfil</FormLabel>
              <CustomInput
                placeholder='Digite um perfil de usuário'
                value={formValues.dscPerfilAcesso.value}
                onChange={(e) => setFormValues({ ...formValues, dscPerfilAcesso: { value: e.target.value, error: false } })}
                maxLength={60}
              />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Situação</FormLabel>
              <RadioGroup
                mt={3.5}
                onChange={(value) => setFormValues({ ...formValues, numRegistro: { value: Number(value), error: false } })}
                value={formValues.numRegistro.value.toString()}
              >
                <Radio value="1" mr={5}>Ativo</Radio>
                <Radio value="0">Inativo</Radio>
              </RadioGroup>
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl>
              <Flex justify="space-between" align="center" mb="8px">
                <FormLabel mb="8px">
                  Selecione quais menus este perfil pode ter acesso
                </FormLabel>
              </Flex>
              <JqxTreeGrid
                ref={treeGridRef}
                width={'100%'}
                source={new jqx.dataAdapter(getSource())}
                columns={columns}
                sortable={true}
                checkboxes={true}
                hierarchicalCheckboxes={true}
                onRowCheck={handleCheckChange}
                onBindingComplete={() => {
                  const mergedMenus = mergeMenuData();
                  mergedMenus.forEach(menu => {
                    const rowKey = menu.codMenu.toString();
                    if (menu.numRegistro === 1) {
                      treeGridRef.current!.checkRow(rowKey);
                    } else {
                      treeGridRef.current!.uncheckRow(rowKey);
                    }
                  });
                  treeGridRef.current!.expandAll();
                }}
              />
            </FormControl>
          </div>
        </div>
      )}

      <Box alignItems={'flex-end'}>
        <Button m="px" onClick={() => navigate(-1)}>
          Desistir
        </Button>
        <Button
          m="6px"
          color="#FFF"
          bgColor="#1665D8"
          _hover={{ opacity: 0.8 }}
          onClick={handleSubmit}
          isDisabled={!isFormValid()}
        >
          Editar Perfil de Usuário
        </Button>
      </Box>
    </Flex>
  );
}

export default EditarPerfilUsuario;
